<app-title-bar [title]='"Medición"' [icon]="'straighten'"></app-title-bar>
<div id="divMeasurement">
  <mat-action-list>
    <mat-list-item (click)="measureArea()">
      <mat-icon>square_foot</mat-icon> Área
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item mat-list-item (click)="measureDistance()">
      <mat-icon>straighten</mat-icon> Distancia
    </mat-list-item>
  </mat-action-list>

  <div id="results" class="results">
    <div class="titleResult" *ngIf="this.measurementWidget.activeTool">Resultado</div>
    <div id="measurementWidget" class="measurementWidget"></div>
    <!-- <div class="divClearButton" *ngIf="this.measurementWidget.activeTool">
      <button mat-icon-button (click)="measurementWidget.clear()" >
        <mat-icon class="clear">delete</mat-icon>
      </button>
    </div> -->
  </div>
</div>